__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/4d21452/_next/";